import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/joy-awards-build-folder/joy-awards-frontend-v3/src/components/gallery/index.tsx");
